import React from 'react';
import ListLayoutComponent from './shared/ListLayoutComponent';
import SingleCoRuleComponent from './SingleCoRuleComponent';
import CoRuleEditorCreate from './editors/CoRuleEditorCreate';
import {CoRulesProvider, useCoRulesContext} from '../contexts/CoRulesContext';

interface Props {
  fieldId: string;
}

function InternalCoRuleComponent({fieldId}: Props) {
  const {corules, loading} = useCoRulesContext();
  const editor = <CoRuleEditorCreate partial={{resource_id: fieldId, resource_type: 'field'}} />;
  const children = corules?.map((corule) => <SingleCoRuleComponent corule={corule} key={corule.corule_id} />);
  return <ListLayoutComponent title={'Conditional Rules'} children={children} editor={editor} loading={loading} />;
}

export default function ListFieldCoRuleComponent({fieldId}: Props) {
  return (
    <CoRulesProvider resourceId={fieldId}>
      <InternalCoRuleComponent fieldId={fieldId} />
    </CoRulesProvider>
  );
}
